import React from 'react'
import Clients from './Clients';
import Slider from 'react-slick'
import ChooseUs from './ChooseUs';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cards';

// import required modules
import { EffectCards} from 'swiper/modules';
import { Link, NavLink } from 'react-router-dom';
import Testimonials from './Testimonials';
import { ModalForm } from '../Common/ModalForm';


const AllSections = () => {
  var settings = {
    dots: false,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,
    speed: 4000,
    mouseDrag:true,
    touchDrag:true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const whatdoCards = [
    {
      id: 1,
      path1: `M0,353h496.8v3.4c0,15.2-6.1,29.9-16.8,40.6c-10.8,10.8-25.4,16.8-40.6,16.8H304.5v43.4l44.2,0
      c5.5,0,9.9,4.5,9.9,9.9c0,5.5-4.5,9.9-9.9,9.9H148.1c-5.5,0-9.9-4.5-9.9-9.9c0-5.5,4.5-9.9,9.9-9.9l44.2,0v-43.4H57.5
      c-15.2,0-29.8-6.1-40.6-16.8C6.1,386.3,0,371.7,0,356.4C0,356.4,0,353,0,353z M166.5,83.3l-12,20.4c-12.1,20.1-9.9,46,5.6,63.9
      l23.2,26.8c-0.4,1.9-0.7,3.9-0.8,5.9c-1.7,21.3-5.5,89.9-7.7,131.1c0,0.6,0,1.2,0,1.8H0V140.7c0-15.2,6.1-29.8,16.8-40.6
      c10.8-10.8,25.4-16.8,40.6-16.8H166.5z M330.3,83.3h109.1c15.2,0,29.8,6.1,40.6,16.8c10.8,10.8,16.8,25.4,16.8,40.6v192.5H322.1
      c0-0.6,0-1.2,0-1.8c-2.2-41.2-6.1-109.8-7.7-131.1c-0.2-2-0.4-4-0.8-5.9l23.2-26.8c15.5-17.9,17.7-43.8,5.5-64.1l-0.7-1.1
      c-0.2-0.4-0.5-0.9-0.7-1.4L330.3,83.3z M194.3,333.3c2.7-47.4,6.6-114.5,7.9-131.4c1.2-15,13.7-26.6,28.7-26.6h34.9
      c15.1,0,27.6,11.6,28.7,26.6c1.4,17.8,5.3,85.6,7.8,131.4H194.3z M192.3,174.6l-17.2-19.9c-9.9-11.5-11.3-28-3.5-41L238.5,0v120.4
      c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9V0l66.9,113.7c7.8,13,6.4,29.5-3.5,41l-17.2,19.9c-8.9-11.6-22.9-19.1-38.6-19.1h-34.9
      C215.3,155.5,201.2,163,192.3,174.6L192.3,174.6z`,
      class: 'icon-1',
      pathUrl:'/website',
      heading: 'Responsive Web Design',
      pera: 'Your brand should be present in online world to have its share from billion searches conducted on Google alone every day no business can afford to go without a website that can transform a searcher into a prospect/customer.'
    },
    {
      id: 2,
      path1: `M391.9,487.9c-26.7-11.9-46.3-35.7-52.7-64.3c-0.3-1.3-1-2.4-2-3.3c-9.9-8.5-18.1-18.8-24.4-30.2
			c-7.3-12.8-2.8-29.1,10-36.3c5.3-3,11.6-4.1,17.6-3.1c3.2,0.6,6.5,0.8,9.8,0.6c1.8-0.1,3.4-1,4.5-2.4c12.6-17.3,31-29.5,51.9-34.4
			c2.7-0.6,4.6-3,4.6-5.8v-43.8c0-3-2.2-5.5-5.2-6c-3.5-0.5-6.6-1.1-9.4-1.8c-11.9-2.9-23.2-7.9-33.3-14.7c-1.1-0.8-2.4-1.2-3.8-1
			c-14.7,0.8-29.4-1-43.4-5.4c-22.1-5.7-27-37.4-7.7-49.6c3.7-2.5,7.1-5.5,10-8.9c1.2-1.3,1.7-3.1,1.4-4.8c-2.7-19,0-38.3,7.8-55.8
			c14.1-32,43.7-54.5,78.4-59.3c3.1-0.4,5.3-3.2,5.1-6.2C409.6,22.6,385.9,0,357,0H153c-29.8,0-54,24.2-54,54v89.2
			c0,3.3,2.8,6,6.1,6c0.2,0,0.4,0,0.5,0c4.6-0.5,9.2-0.7,13.8-0.8c51.7,0,98.5,30.3,119.9,77.3c0.7,1.6,2,2.8,3.6,3.3
			c7.7,2.5,15.8,3.8,23.9,3.8c17.3,0.1,31.2,14.2,31.1,31.4c0,7.1-2.5,14-7,19.6c-12.5,15.8-27.9,29.1-45.5,39
			c-1.3,0.7-2.3,1.8-2.8,3.2c-19.2,51.6-68.5,85.7-123.5,85.6c-4.5,0-9.1-0.3-13.6-0.8c-3.3-0.3-6.3,2.1-6.6,5.5c0,0.2,0,0.3,0,0.5
			V458c0,29.8,24.2,54,54,54h204c13.5,0,26.5-5.1,36.4-14.2c2.4-2.2,2.6-6,0.3-8.5C393.3,488.7,392.6,488.2,391.9,487.9L391.9,487.9
			z M217.4,44c-9.4-0.3-17.8-5.7-22-14.1L185.9,12h138.4l-9.6,17.9c-4.2,8.4-12.6,13.8-22,14.1H217.4z M297,460h-84
			c-3.3,0-6-2.7-6-6s2.7-6,6-6h84c3.3,0,6,2.7,6,6S300.4,460,297,460z`,
      path2: `M421,412h15.8l4.3-16h-15.8L421,412z`,
      path3: `M398.3,329.6c-15.7,6.3-28.9,17.5-37.7,31.8c-0.3,0.4-0.7,0.7-1.2,0.8c-7,1.4-14.2,1.5-21.2,0.3
			c-7.9-1.3-15.5,4-16.8,11.9c-0.6,3.3,0,6.7,1.7,9.6c6.4,11.9,15.3,22.2,26,30.3c0.4,0.3,0.6,0.7,0.7,1.1
			c5.6,38.6,41.9,69.1,79.8,68.7c44.1-0.5,79.5-36.7,79-80.8c-0.2-16-5.1-31.5-14.2-44.6C473.1,327.9,433.3,315.8,398.3,329.6
			L398.3,329.6z M465,396h-11.5l-4.3,16H461c3.3,0,6,2.7,6,6s-2.7,6-6,6h-15l-3.8,14.3c-0.9,3.2-4.2,5.1-7.4,4.2s-5.1-4.2-4.2-7.4
			l0,0l3-11.2h-15.8l-3.9,14.5c-0.9,3.2-4.2,5.1-7.4,4.2s-5.1-4.2-4.2-7.4l3-11.4H397c-3.3,0-6-2.7-6-6s2.7-6,6-6h11.5l4.3-16H401
			c-3.3,0-6-2.7-6-6s2.7-6,6-6h15l3.8-14.3c0.9-3.2,4.2-5.1,7.4-4.2s5.1,4.2,4.2,7.4l-3,11.2h15.8l3.9-14.5c0.9-3.2,4.2-5.1,7.4-4.2
			s5.1,4.2,4.2,7.4l0,0l-3.1,11.4h8.3c3.3,0,6,2.7,6,6S468.4,396,465,396z`,
      path4: `M338.4,121.8c-7.7,17.3-9.8,36.7-5.8,55.2c0.2,0.8,0,1.6-0.5,2.3c-4.6,6.7-10.4,12.5-17.1,17.1c-7.2,4.9-9,14.8-4,22
			c2,2.9,5,5.1,8.4,6.1c14.3,4.6,29.4,6.1,44.3,4.3c0.7-0.1,1.4,0.1,1.9,0.5c15.8,12,35.1,18.6,54.9,18.7
			c65.7,0.3,109.9-71.6,79.5-130.7C466,51.1,368.7,53.4,338.4,121.8L338.4,121.8z M426.5,198.6c-3.4,1.9-7.6,1.9-11,0
			c-23.5-13.3-36.8-29.9-36.2-50.9c-0.1-13,10.4-23.6,23.4-23.7c0,0,0,0,0,0c7.1,0,13.9,3.3,18.3,8.9c4.4-5.6,11.2-8.9,18.3-8.9
			c13,0.1,23.5,10.6,23.4,23.7c0,0,0,0,0,0C463.4,168.6,450,185.2,426.5,198.6z`,
      path5: `M233,317.6c0.5-1.4,1.5-2.6,2.9-3.3c17.8-9.2,33.5-22.2,45.8-38.1c6.7-8.3,5.4-20.4-2.9-27.1c-3.4-2.7-7.6-4.2-11.9-4.3
			c-11.3-0.1-22.5-2.2-33-6.4c-1.6-0.6-2.9-1.8-3.5-3.4c-9.5-23.5-26.2-43.3-47.7-56.6c-84.6-53-193,17.4-181.8,116
			C7.4,352.8,61.4,401,119.5,399.8C168.6,400.8,218.1,365.7,233,317.6L233,317.6z M91,330.9c-1.8,1.1-3.9,1.6-6,1.6H69
			c-6.6,0-12-5.4-12-12v-60c0-6.6,5.4-12,12-12h16c2.1,0,4.2,0.5,6,1.6V330.9z M103,325.5v-71.9c11.8-10.9,19.3-33.1,24.3-43.6
			c8.9-18.4,26.7,6.3,22.4,19.6c-1.5,4.6-4.7,18.8-4.7,18.8c19.9,0,36,16.1,36,36l0,0v12c0,19.9-16.1,36-36,36h-22.3
			c-3.7,0-7.4-0.9-10.7-2.5L103,325.5z`,
      class: 'icon-2',
      pathUrl:'/digital-marketing',
      heading: 'Online Marketing',
      pera: 'The way in which digital marketing has developed, now it’s become vital to explore activities such SEO, SEM, content marketing, campaign marketing, social media marketing, social media optimization etc which has changed the way brands and businesses do marketing.'
    },
    {
      id: 3,
      path1: `M368.5,482h-33.2v-36.4H176.7V482h-33.2c-8.3,0-15,6.7-15,15s6.7,15,15,15h224.9c8.3,0,15-6.7,15-15S376.8,482,368.5,482z`,
      path2: `M464.9,64.3H459c-2,2.9-4.3,5.7-6.9,8.2c-30.7,30.7-91.8,75.6-146.9,114c-33.6,23.5-64.9,44.2-82.1,55.5
      c4.9,9,7.7,19.2,7.7,30.1c0,11.1-0.9,79.3-111.4,79.3H87.3c-6.6,0-12.4-4.3-14.4-10.7c-1.9-6.3,0.5-13.2,6-16.8
      c19.7-13.2,25.5-24.8,25.5-51.8c0-34.8,28.4-63.2,63.2-63.2c10.9,0,21.2,2.8,30.1,7.7c11.3-17.3,32.5-49.2,56.3-83.3
      c15.9-22.9,33-46.7,49.6-69H47.1C21.1,64.3,0,85.4,0,111.4v257.1c0,26,21.1,47.1,47.1,47.1h417.7c26,0,47.1-21.1,47.1-47.1V111.4
      C512,85.4,490.9,64.3,464.9,64.3L464.9,64.3z`,
      path3: `M431,51.3c11.7-11.7,11.7-30.8,0-42.5c-11.7-11.7-30.8-11.7-42.5,0c-35.5,35.5-92.4,115.6-133.1,175.6
      C315.3,143.6,395.4,86.8,431,51.3L431,51.3z`,
      path4: `M167.6,238.9c-18.3,0-33.2,14.9-33.2,33.2c0,20.6-3.3,36.2-11,49.2c29.5-0.5,51.6-6.8,64.3-18.2c8.7-7.9,13.1-18.3,13.1-31
      C200.8,253.8,185.9,238.9,167.6,238.9L167.6,238.9z`,
      class: 'icon-3',
      pathUrl:'/branding',
      heading: 'Corporate Branding Solutions',
      pera: 'We work with you in process involved in creating a unique logo/image for a product, packaging or merchandise branding, a calendar, offline print tools like fliers, hoarding, corporate stationery, we provide a complete solution customized and delivered within defined time.'
    },
    {
      id: 4,
      path1: `M512,96V48c0-26.5-21.5-48-48-48H48C21.5,0,0,21.5,0,48v48H512z M336,32h128c8.8,0,16,7.2,16,16s-7.2,16-16,16H336
      c-8.8,0-16-7.2-16-16S327.2,32,336,32z M176,32h16c8.8,0,16,7.2,16,16s-7.2,16-16,16h-16c-8.8,0-16-7.2-16-16S167.2,32,176,32z
       M112,32h16c8.8,0,16,7.2,16,16s-7.2,16-16,16h-16c-8.8,0-16-7.2-16-16S103.2,32,112,32z M48,32h16c8.8,0,16,7.2,16,16
      s-7.2,16-16,16H48c-8.8,0-16-7.2-16-16S39.2,32,48,32z`,
      path2: `M205.1,352h134.8l22.9-80H189.1L205.1,352z`,
      path3: `M0,128v336c0,26.5,21.5,48,48,48l0,0h416c26.5,0,48-21.5,48-48l0,0V128H0z M216,448c-13.3,0-24-10.7-24-24s10.7-24,24-24
      s24,10.7,24,24S229.3,448,216,448z M312,448c-13.3,0-24-10.7-24-24s10.7-24,24-24s24,10.7,24,24S325.3,448,312,448z M399.4,260.4
      l-28.7,100.4c-4,13.7-16.5,23.2-30.8,23.2H205.1c-15.2,0-28.3-10.8-31.4-25.7L146.9,224H112c-8.8,0-16-7.2-16-16s7.2-16,16-16h48
      c7.6,0,14.2,5.3,15.7,12.8l7,35.2H384c8.8,0,16,7.2,16,16C400,257.5,399.8,259,399.4,260.4z`,
      class: 'icon-4',
      pathUrl:'/ecommerce-webdesign-in-delhi',
      heading: 'E-Commerce Development',
      pera: 'A website for your business- is your identity to the rest of the world. Our e-commerce developers understand the importance of building a secure, intuitive and well-Shaped website.'
    },
    {
      id: 5,
      path1: `M56.8,512h290.4c31.3,0,56.7-25.4,56.8-56.8V56.8c0-31.3-25.4-56.7-56.8-56.8H56.8C25.4,0,0,25.4,0,56.8v398.5
      C0,486.6,25.4,512,56.8,512L56.8,512z M215.4,289.9l33.9-33.9l-33.9-33.9c-5.2-5.3-5-13.8,0.3-19c5.2-5.1,13.5-5.1,18.7,0l33.9,33.9
      l33.9-33.9c5.2-5.3,13.7-5.3,19-0.1c5.3,5.2,5.3,13.7,0.1,19c0,0-0.1,0.1-0.1,0.1L287.3,256l33.9,33.9c5.2,5.2,5.2,13.7,0,19
      c-5.2,5.2-13.7,5.2-19,0L268.3,275l-33.9,33.9c-5.3,5.2-13.8,5.2-19-0.1C210.2,303.6,210.2,295.2,215.4,289.9L215.4,289.9z
       M78.8,261.8v-49.3c0.1-7.4,6.1-13.4,13.5-13.3c7.3,0.1,13.2,6,13.3,13.3v49.3c0.1,13.4,11,24.1,24.4,24.1
      c13.3-0.1,24-10.8,24.1-24.1v-49.3c0.1-7.4,6.1-13.4,13.5-13.3c7.3,0.1,13.2,6,13.3,13.3v49.3c0,28.2-22.9,51.1-51.1,51.1
      S78.8,290,78.8,261.8L78.8,261.8z M202,407.7L202,407.7c7.4,0,13.4,6,13.4,13.4c0,7.4-6,13.4-13.4,13.4c-7.4,0-13.4-6-13.4-13.4
      C188.6,413.7,194.6,407.8,202,407.7z`,
      class: 'icon-5',
      pathUrl:'/mobileuiuxdesign',
      heading: 'Mobile UX/Ui Design',
      pera: 'Mobile Application (App) Development is an area that needs compelling user interface design. We craft experiences that transform brands and help grow businesses.'
    }
  ]

  const priceData = [
    {
      id:1,
      planName:'Business HTML Website',
      price:'15,000',
      list1:'Up to 3-5 Website Pages',list2:'Fully Responsive',list3:'Free Logo Design With two revision',list4:' Web Hosting',list5:' 1 Email Account',list6:'Admin Access',
      iconSrc:'./images/icons/briefcase.svg',
      class:'fa-xmark text-danger'
    },
    {
      id:2,
      planName:'Wordpress Website',
      price:'20,000',
      list1:'Up to 5-7 Website Pages',list2:'Fully Responsive',list3:'Free Logo Design With three revision',list4:' Web Hosting',list5:' 2 Email Account',list6:'Admin Access',
      iconSrc:'./images/icons/wordpress-logo.svg',
      class:'fa-check text-success'
    },
    {
      id:3,
      planName:'WordPress Ecommerce Website',
      price:'35,000',
      list1:'Up to 10-15 Website Pages',list2:'Fully Responsive',list3:'Free Logo Design With five revision',list4:' Web Hosting',list5:' 2 Email Account',list6:'Admin Access',
      iconSrc:'./images/icons/online-shopping.svg',
      class:'fa-check text-success'
    }
  ]
  return (
    <>
        <Clients />
      <section className='expertise section'>
        <div className="container">
          <div className="row">
            <div className="col-md-6 position-relative">
              <img src="./images/expertise1.webp" className='w-100' alt="" />
              {/* <img src="./images/rocket.webp" className='position-absolute rocket' alt="" /> */}
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-center">
              <span className='span_head'>Our Expertise</span>
              <h2 className='heading my-3'>A Website for Your Business</h2>
              <div className="heading-divider mb-4"></div>
                          <p>A website for your business- is your identity to the rest of the world. Our team of designers & developers understands the importance of building a secure, intuitive, and web-structured website, both in terms of the information it gives and the experience it provides to website visitors.</p>
              <p>Working on a variety of websites, utilizing some of the industry’s most popular technologies and methodologies, we provide a website for you to thrive in! We see the project as a mission, not just a website.</p>
              <div className='mt-4'>
                <NavLink className="text-decoration-none drona-btn btn" to="/who-we-are">Find more about us</NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='what-we-do section'>
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <span className='span_head'>What We Do</span>
              <h3 className='heading mt-3'>Services To Help Your Business Grow</h3>
              <div className="heading-divider mb-4"></div>
            </div>
            <div className="col-md-7 my-auto">
                          <p >With years of experience in web design and development, we realize it is essential not only to have a nice-looking website but also to have a thematic and clearly convey its purpose in a way that would appeal to the audiences! We at website Drona use the best tools and latest technologies to create effective and meaningful to-the-business designs so that you can have a personal brand style and be targeted to the goal.
                          </p>
            </div>
          </div>
          <div className="col-12">
            <Slider {...settings}>
              {whatdoCards.map((curElem) =>
                <div key={curElem.id}>
                  <div className="card mybg myshadow">
                    <div className={`icon mx-auto my-3 d-flex justify-content-center align-items-center ${curElem.class}`}>
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="60" viewBox="0 0 496.8 477.2" style={{ overflow: 'visible', enableBackground: 'new 0 0 496.8 477.2' }}
                        space="preserve">
                        <defs>
                        </defs>
                        <path d={curElem.path1} />
                        <path d={curElem.path2} />
                        <path d={curElem.path3} />
                        <path d={curElem.path4} />
                        <path d={curElem.path5} />
                      </svg>
                    </div>
                    <div className="h5 mt-2">{curElem.heading}</div>
                    <p>{curElem.pera}</p>
                    <Link to={curElem.pathUrl}>READ MORE <i className="fa-solid fa-arrow-right"></i></Link>
                  </div>
                </div>
              )}
            </Slider>
          </div>
        </div>
      </section>

      <section className='section our_work' style={{backgroundColor:'#222a36'}}>
          <div className="container">
            <div className="row">
              <div className="col-md-5 my-auto">
                <span className='span_head text-white'>Our Work</span>
                <h3 className='heading mt-3 text-white'>We Are Proud of Everything We Create</h3>
                <div className="heading-divider mb-4"></div>
                <div className='mt-4'>
                <Link className="text-decoration-none drona-btn btn" to="/portfolio">See All Work</Link>
                </div>
              </div>
              <div className="col-md-7 overflow-hidden">
              <div className="swiper_wrapper">
              <Swiper
                effect={'cards'}
                grabCursor={true}
                modules={[EffectCards]}
                className="mySwiper"
              >
                 <SwiperSlide>
                  <img src="./images/work1.webp" alt="Best WebDesign in Delhi" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="./images/work2.webp" alt="Best WebDesign in Delhi" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="./images/work3.webp" alt="Best WebDesign in Delhi" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="./images/work4.webp" alt="Best WebDesign in Delhi" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="./images/work5.webp" alt="Best WebDesign in Delhi" />
                </SwiperSlide>
              </Swiper>
              </div>
              </div>
            </div>
          </div>
      </section>

      <ChooseUs />

      <section className='text-center' style={{background:'#222a36'}}>
        <div className="container">
          <img src="./images/logos-bar.jpg" className='w-75' alt="" />
        </div>
      </section>

      {/* -----------------------price card-------------------------------------- */}

      <section className='promise section'>
        <div className="container">
          <div className="row">
            <div className="col-md-5 mb-3 mb-md-0">
              <span className='span_head'>Our goal</span>
              <h3 className='heading mt-3'>Our Promise to You!</h3>
              <div className="heading-divider mb-1 mb-md-4 mx-auto  "></div>
              <div className='mt-3'>
                  <Link className="text-decoration-none drona-btn btn" to="/contact-us">Connect with us</Link>
              </div>
            </div>
            <div className="col-md-7 my-auto">
                          <p>As a Web Design and Development Company, we promise to provide maximum ROI for the Time & money you invest with us. Your satisfaction remains our number one priority, and we will stop at nothing but perfection to make sure it is met.                          </p>
              <p>In addition to surpassing your expectations, we are committed to growing your business. Our goal is to provide world-class web design and development services to anyone who chooses to work with us.</p>
            </div>
          </div>
          <div className="row mt-3 mt-md-5">
            <div className="col-12 text-center mb-5">
                <h3 className='heading mt-3'>Startup Pro Website @ ₹ 15,000/- ONLY.</h3>
                <p className='m-0 mt-3'>Just fill out the form and get your website designed by us.</p>
                <p>Renewal charges for domain, hosting, email are applicable from next year, GST @18% extra.</p>
            </div>
          </div>
            <div className="row price_table">
            {priceData.map((curElem)=>
              <div className="col-md-4" key={curElem.id}>
              <div className="card py-3 px-2 px-md-4 py-md-4">
                <div className="card-head d-flex align-items-center">
                  <div className="icon d-flex justify-content-center align-items-center">
                    <img src={curElem.iconSrc} alt="" />
                  </div>
                  <h5 className='fw-bold ms-3'>{(curElem.planName)}</h5>
                </div>
                <div className="card-body">
                  <div className='prise_tag'>
                    <span>₹</span> {curElem.price} <span>/-</span>
                  </div>
                  <ul className='list-unstyled p-0 pt-3'>
                    <li className='mb-2'><i className="fa-solid me-2 text-success fa-check"></i> {curElem.list1}</li>
                    <li className='mb-2'><i className="fa-solid me-2 text-success fa-check"></i> {curElem.list2}</li>
                    <li className='mb-2'><i className="fa-solid me-2 text-success fa-check"></i> {curElem.list3}</li>
                    <li className='mb-2'><i className="fa-solid me-2 text-success fa-check"></i> {curElem.list4}</li>
                    <li className='mb-2'><i className="fa-solid me-2 text-success fa-check"></i> {curElem.list5}</li>
                    <li className='mb-2'><i className={`fa-solid me-2 ${curElem.class}`}></i> {curElem.list6}</li>
                  </ul>
                  <div className='mt-3'>
                                <a className="text-decoration-none drona-btn btn w-100 py-0" href="#" type="button" data-bs-toggle="modal"
                                    data-bs-target="#modalId">BUY</a>
                  </div>
                </div>
              </div>
            </div>
            )}
            </div>
        </div>
      </section>

          <Testimonials />

          <section className='promise section free-tools'>
              <div className="container text-center">
                          <h3 className='heading mt-3 text-center'>Free Tools</h3>
                  <div className="heading-divider mb-1 mb-md-4 mx-auto  text-center"></div>
                  <div className='row align-items-center justify-content-center text-center'>
                      <div className='col-md-2'>
                          <Link to='https://biturl.in/' target='_blank'><img src='./images/tools/shortly-logo.png' alt=''/></Link>
                      </div> 
                      <div className='col-md-2'>
                          <Link to='https://shipsagar.com/' target='_blank'><img src='./images/tools/ship-sagar-logo.png' alt='' /></Link>
                      </div>
                      <div className='col-md-2'>
                          <Link to='https://www.einvoicingsoftware.in/' target='_blank'><img src='./images/tools/onlineIRN-logo.png' alt='' /></Link>
                      </div>
                      <div className='col-md-2'>
                          <Link to='https://domainsagar.com/' target='_blank'><img src='./images/tools/domain-sagar-logo.png' alt='' /></Link>
                      </div>
                  </div>
              </div>
            </section>

          <ModalForm/>
    </>
  )
}

export default AllSections